// ==============================|| OVERRIDES - LIST ITEM BUTTON ||============================== //

export default function ListItemButton(theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          marginBottom: '4px',
          '&:hover': {
            backgroundColor: theme.palette.secondary.lighter,
            '& .MuiListItemIcon-root': {
              color: theme.palette.secondary.main
            },
            '& .MuiTypography-root': {
              color: theme.palette.secondary.main
            }
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.secondary.lighter,
            '& .MuiListItemIcon-root': {
              color: theme.palette.secondary.main
            },
            '& .MuiTypography-root': {
              color: theme.palette.secondary.main,
              fontWeight: 500
            },
            '&:hover': {
              backgroundColor: theme.palette.secondary.light
            }
          }
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: theme.palette.text.secondary,
          transition: 'all 0.2s ease'
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          '& .MuiTypography-root': {
            color: theme.palette.text.primary,
            fontSize: '0.875rem',
            transition: 'all 0.2s ease'
          }
        }
      }
    }
  };
}
